import React from "react";
import styled from "styled-components";
import { ReportsDateFilters } from "reports/components/ReportsDateFilters";
import { PriorityFilters } from "tasks/components/Filters/PriorityFilters";
import { TaskTypeFilters } from "tasks/components/Filters/TaskTypeFilters";

const Container = styled.div`
  display: flex;
  flex-direction: row;

  > *:not(:last-child) {
    margin-right: 0.429rem;
  }
`;

export const ReportsFilters = () => {
  return (
    <Container>
      <TaskTypeFilters />
      <PriorityFilters />
      <ReportsDateFilters />
    </Container>
  );
};
